import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setOrgChangedModalVisible } from '../../src/store/actions/modals';
import { selectOrganizationInfo } from '../../src/store/selectors/auth';
import { ORG_ID, STORAGE_EVENT } from '../constants/organizations';
import { changeOrganizationsRequest } from '../store/actions/auth';

export const useGlobalOrgChangeListener = () => {
  const orgInfo = useSelector(selectOrganizationInfo);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (orgInfo?.uid) {
      window.localStorage.setItem(ORG_ID, orgInfo.uid);
    }
  }, [orgInfo?.uid]);

  const handleStorageChange = React.useCallback(
    (event: StorageEvent) => {
      const currentOrgId = orgInfo?.uid;
      if (event.key !== ORG_ID || !currentOrgId) {
        return;
      }

      const localStorageOrgId = localStorage.getItem(ORG_ID);
      const isDifferent = localStorageOrgId !== currentOrgId;
      dispatch(setOrgChangedModalVisible(isDifferent));
    },
    [orgInfo?.uid, dispatch],
  );

  const handleResume = () => {
    if (!orgInfo?.uid) {
      return;
    }
    localStorage.setItem(ORG_ID, orgInfo.uid);
    dispatch(setOrgChangedModalVisible(false));
    dispatch(changeOrganizationsRequest({ org_id: orgInfo.uid, resolve: null, reject: null, isSilent: true }));
  };

  React.useEffect(() => {
    window.addEventListener(STORAGE_EVENT, handleStorageChange);
    return () => {
      window.removeEventListener(STORAGE_EVENT, handleStorageChange);
    };
  }, [orgInfo?.uid, handleStorageChange]);

  return { handleResume };
};
